export default __webpack_public_path__ + "static/media/Annotation_manager.9be762e5.png";